import { observer } from 'mobx-react-lite';
import { Group, Modal, Stack } from '@mantine/core';
import { PostResponse } from '@/queries/posts/usePost';
import { PostChecklist } from './PostChecklist/PostChecklist';
import { PostContent } from './PostContent';
import { PostDate } from './PostDate';
import { PostTitle } from './PostTitle';
import classes from './PostModal.module.css';

export const PostModal = observer(
  ({ post, onClose }: { post: PostResponse; onClose: () => void }) => {
    return (
      <Modal.Root
        size="xl"
        opened
        onClose={onClose}
        className={classes.PostModal}
        lockScroll={false}
      >
        <Modal.Overlay />
        <Modal.Content>
          <Modal.CloseButton className={classes.PostModalCloseButton} />
          <Modal.Body>
            <Stack gap="sm">
              <Group gap="sm">
                <PostTitle post={post} />
                <PostDate post={post} />
              </Group>

              <PostContent post={post.post} />

              {/* <PostAttachments post={post} /> */}

              <PostChecklist post={post} />

              {/* <PostComments post={post} /> */}
            </Stack>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    );
  }
);
